module.exports = __webpack_public_path__ + "img/learnModel-ball-lg-mobile.d875f378.png";